require(['jquery'], function ($) {

  if ($(".xm-grid-product").length > 0 && $('button.btn-cart').length > 0) {
    $('body').append("<div class='add-cart-fixed' style='display: none;'><span>" + $('button.btn-cart').text() +"</span></div>");
    $('body').on('click', '.add-cart-fixed', function () {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".product-shop").offset().top
      }, 1000);

      $('.product-options').addClass('border-out');

    });
  }

  let isScrolledIntoView = function (elem) {
    let docViewTop = $(window).scrollTop();
    let docViewBottom = docViewTop + $(window).height();

    let elemTop = $(elem).offset().top;
    let elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  };

  var halfScreenSize = ($(document).width() * 0.5);
  $(window).scroll(function() {
    if ($('button.btn-cart').length > 0) {
      var isVisibleOnScreen = isScrolledIntoView('button.btn-cart');
      if (isVisibleOnScreen) {
        $('.add-cart-fixed').hide();
        $('.add-cart-fixed').width('50%');
      } else {
        if ($('.add-cart-fixed').width() === halfScreenSize) {
          $('.add-cart-fixed').show().animate({width: '100%'});
        }
      }
    }
  });

  if ($("#mini-cart").length > 0) {
    $("#mini-cart .icon.i-cart").removeClass("icon i-cart").addClass("fa fa-shopping-cart");
  }

  $(".form-search .button.button-search").html("<i class='fa fa-search'></i>");


  if ($(".variant-option").length > 0) {
    if ($(".variant-option .swatches-con .swatch img").length > 0) {
      $(".variant-option .swatches-con").css('display', 'block');
    }
  }


  // const banner = document.querySelector('.zoom-banner');
  // const wrapper = document.querySelector('.zoom-banner .page-content');
  // console.log(banner);
  //
  // banner.addEventListener('scroll', () => {
  //   const scrollPosition = banner.scrollTop + (banner.offsetHeight / 2);
  //   console.log(scrollPosition);
  //
  //   const imageCenter = wrapper.offsetHeight / 2;
  //   const scale = scrollPosition >= imageCenter ? 1.5 : 1;
  //   wrapper.style.transform = `scale(${scale})`;
  // });

  // Get all elements with the class zoom-banner
  const banners = document.querySelectorAll('.zoom-banner');

// Loop through each banner
  banners.forEach((banner) => {
    // Get the image inside the banner
    const image = banner.querySelector('img');

    // Add an event listener to the window scroll event
    window.addEventListener('scroll', () => {
      // Calculate the distance from the top of the window to the banner
      const distanceFromTop = banner.getBoundingClientRect().top;

      // Calculate the distance from the center of the window to the banner
      const distanceFromCenter = Math.abs(distanceFromTop - window.innerHeight / 2);

      // Calculate the scale factor based on the distance from the center
      // const scaleFactor = 1 - (distanceFromCenter / (window.innerHeight / 2));

      // console.log(distanceFromCenter);

      const scaleFactor = distanceFromCenter > 100 ? 1.2 : 1;

      // Apply the scale factor to the image
      image.style.transform = `scale(${scaleFactor})`;
    });
  });


 



});
